import { AreaService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as area from './types';
import * as common from '@common/store/modules/common/types';
//import * as commonGetters from '@common/store/modules/common/getters';

const actions = {
  async [area.AREA_RESET_STATE](context) {
    context.commit(area.AREA_RESET_STATE);
  },

  async [area.FETCH_CURRENT](context, params) {
    const { data } = await AreaService.current(params);
    context.commit(area.SET_MY_AREA, data);

    return data;
  },
  async [area.FETCH_DONG](context, params) {
    const { data } = await AreaService.searchDong(params);
    context.commit(area.SET_AREA, data);

    return data;
  },
  async [area.FETCH_NEARBY](context, payload) {
    const { data } = await AreaService.searchNearby(payload);
    context.commit(area.SET_AREA, data);

    return data;
  },
  async [area.FETCH_SELECTED_NEARBY](context, payload) {
    const { data } = await AreaService.searchSelectedNearby(payload);
    context.commit(area.SET_AREA, data);

    return data;
  },
  async [area.UPDATE_REGION](context, payload) {
    const { data } = await AreaService.setArea(payload);
    context.commit(area.SET_AREA, data);
    return data;
  },
};

export default actions;
